export function isValidEmail(email = '') {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

export function getPasswordStrength(password = '') {
  if (!password) return 0;

  let score = 0;
  if (password.length >= 8) score += 1;
  if (password.length >= 12) score += 1;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score += 1;
  if (/\d/.test(password)) score += 1;
  if (/[^A-Za-z0-9]/.test(password)) score += 1;
  return Math.min(score, 5);
}

export function validateNewPassword(password = '', confirmation = '') {
  const errors = {};

  if (!password) {
    errors.password = 'Passwort ist erforderlich.';
  } else if (password.length < 8) {
    errors.password = 'Verwenden Sie mindestens 8 Zeichen.';
  }

  if (!confirmation) {
    errors.confirmPassword = 'Bitte wiederholen Sie das Passwort.';
  } else if (password !== confirmation) {
    errors.confirmPassword = 'Die Passwörter stimmen nicht überein.';
  }

  return errors;
}
